import { render, staticRenderFns } from "./Other-resources.vue?vue&type=template&id=b0621188"
import script from "./Other-resources.vue?vue&type=script&lang=js"
export * from "./Other-resources.vue?vue&type=script&lang=js"
import style0 from "./Other-resources.vue?vue&type=style&index=0&id=b0621188&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports